var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.824 19.853L10 17.33l-4.825 2.524c-.909.482-1.99-.292-1.813-1.31l.92-5.35L.379 9.408c-.742-.722-.329-1.975.694-2.123l5.394-.78L8.88 1.637c.42-.85 1.82-.85 2.24 0l2.414 4.866 5.395.78c1.022.148 1.435 1.4.693 2.122l-3.904 3.789.921 5.348c.176 1.024-.907 1.787-1.815 1.311z",
    fillRule: "nonzero"
  })));
}
export default SvgStarRate;